import { BaseModel } from './BaseModel';
import Auth from './Auth';

export class Skill extends BaseModel {
  static get entity() {
    return 'skills';
  }

  static get fk() {
    return 'skill_id';
  }

  static primaryKey = 'runningId';

  static fields() {
    return {
      id: this.attr(null),
      runningId: this.attr(null),
      tscId: this.attr(null),
      title: this.attr(null),
      category: this.attr(null),
      description: this.attr(null),
      emerging: this.attr(null),
      sector: this.attr(null),
      timestamp: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static get globalApiConfig() {
    const headers = {};
    const authToken = Auth.getAppToken();
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
    return {
      baseURL: process.env.VUE_APP_SKILL_API_BASE_URL,
      headers
    };
  }

  static apiConfig = {
    actions: {
      async fetch(body = {}, save = false) {
        return this.post(`/skill/getSkillByRunningIds`, body, { save });
      },

      async search(body = {}, save = false) {
        return this.post(`/skill/search`, body, { save });
      },

      async fetchSkillBySectorId(sectorId) {
        return this.get(`/skill/getSkillBySectorId/${sectorId}`);
      },

      async fetchSkillProficiency(save = false) {
        return this.get(`/skillProficiency/getAvailableSkillProficiencyList`, { save });
      },

      async fetchSkillProficiencyLevelsMapping(body, save = false) {
        return this.post(`/masterSkillProficiency/getMasterSkillProficiencyMapping`, body, {
          save
        });
      }
    }
  };
}

export default Skill;
